<template>
    <div
        v-if="show"
        ref="hashtag-list"
        id="hashtag-list"
        :style="{ top: top + 'px', left: left + 'px' }"
    >
        <div
            v-for="(hashtag, i) in hashtags"
            :key="hashtag.id"
            class="hashtag"
            :class="{ selected: selectedIndex == i }"
            :tabindex="i + 1"
            @click="onClick(i)"
            @mouseover="onHover(i)"
        >
            {{ hashtag.hashtag }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: Boolean,
        hashtags: Array,
        top: Number,
        left: Number,
        selectedIndex: Number
    },
    methods: {
        onClick(index) {
            this.$emit("click", index);
        },
        onHover(index) {
            this.$emit("hover", index);
        }
    }
};
</script>

<style type="text/css" lang="scss">
#hashtag-list {
    position: absolute;
    margin-top: 15px;

    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);
    display: inline-block;

    width: fit-content;
    vertical-align: top;
    z-index: 1150;

    .hashtag {
        padding: 5px 10px;

        &.selected {
            background-color: #dee0e2;
        }

        &:hover {
            background-color: #dee0e2;
        }
    }
}
</style>
